export default {
	sec_01: {
		title: {
			one: 'Request ',
			two: 'conveniently',
		},
		desc: {
			one: 'Friends and family can',
			two: 'request cryptocurrency without notification.',
		},
		btn: {
			one: 'Cryptocurrency Request',
			two: 'Download App',
		},
	},
	sec_09: {
		title: {
			one: 'Convenient Asset',
			two: 'Request Service',
		},
		one: {
			desc: {
				one: 'Convenient, easy-to-use requests',
				two: 'Instant two-way messaging',
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'Free request',
				two: 'service without hassle',
			},
			desc: {
				one: 'Once you request money from your friends and',
				two: 'then wait, money will be deposited automatically.',
			},
		},
		two: {
			title: {
				one: 'Easy Settings',
			},
			desc: {
				one: "If your friend doesn't have a JP WORLD Pay account",
				two: 'only have to do is sign up in a few minutes.',
			},
		},
		three: {
			title: {
				one: 'Select a JP WORLD Pay user and',
				two: 'enter the requested amount',
			},
			desc: {
				one: 'You can simplify the daily reception of cryptocurrency by',
				two: 'instantly creating a link to request assets of JP WORLD Pay.',
			},
			btn: {
				one: 'Creating a JP WORLD Pay Link',
			},
		},
	},
	sec_05: {
		title: "It's easy to send salaries",
		desc: {
			one: 'Open the app and select Receive Payment.',
		},
	},
};
